import { QueryStore } from '../runtime/stores/query'
import artifact from '$houdini/artifacts/ValidateSalesOrder'
import { initClient } from '$houdini/plugins/houdini-svelte/runtime/client'

export class ValidateSalesOrderStore extends QueryStore {
	constructor() {
		super({
			artifact,
			storeName: "ValidateSalesOrderStore",
			variables: true,
		})
	}
}

export async function load_ValidateSalesOrder(params) {
  await initClient()

	const store = new ValidateSalesOrderStore()

	await store.fetch(params)

	return {
		ValidateSalesOrder: store,
	}
}
